import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setBreadcrumbsList } from 'src/store/breadcrumbs';

import { AboutProject } from './aboutProject/AboutProject';
import { AboutUs } from './aboutUs/AboutUs';
import { Security } from './security/Security';
import { Details } from './details/Details';
import { Rewards } from '../home/rewards/Rewards';
import { InvestYourself } from './investYourself/InvestYourself';

import { BREADCRUMBS_DATA } from 'src/constants';

import './aboutCompany.scss';

export const AboutCompany = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBreadcrumbsList(BREADCRUMBS_DATA.ABOUT_COMPANY));
  }, [dispatch]);

  return (
    <div className="about-company">
      <AboutProject />
      <AboutUs />
      <Security />
      <Details />
      <Rewards />
      <InvestYourself />
    </div>
  );
};
